import { ColumnsType } from "antd/es/table";
import dayjs from "../../../../../../configs/dayjs";
import { DATE_FORMAT } from "../../../../../../lib/constants";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { getFormattedCurrency } from "../../../../../../lib/currencyFormatter";
import { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import ROUTES from "../../../../../../configs/routesConfig";

export const useColumns = (
  setRequest: React.Dispatch<React.SetStateAction<any>>,
) => {
  const onSortChange = useCallback(
    (sorter: any, request: any) => {
      const newRequest = { ...request };
      if (!sorter.order) {
        delete newRequest["sort"];
      }

      if (sorter.field === "date") {
        newRequest["sort"] = sorter.order === "ascend" ? 1 : 2;
      }

      if (sorter.field === "contractNumber") {
        newRequest["sort"] = sorter.order === "ascend" ? 3 : 4;
      }

      if (sorter.field === "type") {
        newRequest["sort"] = sorter.order === "ascend" ? 5 : 6;
      }

      setRequest(newRequest);
    },
    [setRequest],
  );

  const columns: ColumnsType<any> = useMemo(
    () => [
      {
        title: "Date",
        dataIndex: "date",
        render: (value: string) => dayjs(value).format(DATE_FORMAT),
        sorter: true,
      },
      {
        title: "Account Number",
        dataIndex: "contractNumber",
        render: (value: number, record: any) => (
          <div className="elipsis">
            <Link
              to={`${ROUTES.ACCOUNTS}/${record.contractId}`}
              target="_blank"
            >
              <span className="ant-btn-link">{value}</span>
            </Link>
          </div>
        ),
        sorter: true,
      },
      {
        title: "Type",
        dataIndex: "type",
        render: (value: number) => (
          <div className="d-flex align-center">
            <div
              className={`mr-2 d-flex justify-center payment-icon ${
                value === 2 && "disb"
              }`}
            >
              {value === 1 ? <ArrowRightOutlined /> : <ArrowLeftOutlined />}
            </div>
            {value === 1 ? "Payment" : "Disbursement"}
          </div>
        ),
        sorter: true,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        render: (value: number) => getFormattedCurrency(value),
      },
    ],
    [],
  );

  return { columns, onSortChange };
};
